// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WvrA-","colBig":"styles_colBig__3wQIG","colSmall":"styles_colSmall__2kLrm"};